








































import Vue, { PropOptions } from 'vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import BorderButton from '@/components/border-button.vue'

export interface Client {
  id: number
  categories: number[]
  oneLetter: string
  clientName: string
  clientDescription: string
  clientSite: string
  gallery: Array<{ src: string; caption: string }>
  projects: Array<{ name: string; url: string }>
  designSelectionAward: boolean
}

export default Vue.extend({
  props: {
    client: {} as PropOptions<Client>
  },

  components: {
    'Swiper': swiper,
    'SwiperSlide': swiperSlide,
    BorderButton
  },

  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      }
    }
  },

  watch: {
    'client'() {
      if (Object.keys(this.client).length > 0) {
        document.body.style.height = '100vh'
        document.body.style.overflow = 'hidden'
        // if (this.client.gallery.length < 2)
        this.initSwiper()
      } else {
        document.body.style.height = ''
        document.body.style.overflow = ''
      }
    }
  },

  methods: {
    close() {
      this.$emit('close-modal')
    },

    initSwiper() {
      if (this.client.gallery.length < 2) return

      // @ts-ignore
      const imgs: HTMLImageElement[] = Array.from(this.$refs.gallery.$el.querySelectorAll('img'))
      // @ts-ignore
      const promises: Array<Promise<void>> = imgs.map(img => {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          img.addEventListener('load', () => resolve())
          img.addEventListener('error', () => reject())
        })
      })
      // @ts-ignore
      (Promise as any).allSettled(promises).then(() => this.$refs.gallery.swiper.update())
    }
  }
})
